import { handleActions } from 'redux-actions';
import { actions } from './actions';

export { actions };
export { sagas } from './sagas';

const defaultState = {
  documentsById: {},
  documentsAllIds: [],
  searchIndex: undefined,
};

export const reducer = handleActions(
  {
    [actions.setDocuments]: (state, { payload }) => {
      return {
        ...state,
        documentsById: payload.byId,
        documentsAllIds: payload.allIds,
      };
    },
    [actions.setSearchIndex]: (state, { payload }) => {
      return {
        ...state,
        searchIndex: payload,
      };
    },
  },
  defaultState
);
